import React, { useEffect } from 'react';
import { Drawer } from '@one-thd/sui-atomic-components';
import { PerksListDrawer } from './PerkDrawer/PerksListDrawer';
import { PerkDetailsDrawer } from './PerkDrawer/PerkDetailsDrawer';
import { OffersListDrawer } from './OfferDrawer/OffersListDrawer';
import { RewardsListDrawer } from './RewardsDrawer/RewardsListDrawer';
import { OfferDetailsDrawer } from './OfferDrawer/OfferDetailsDrawer';
import { ChallengeDetailsDrawer } from './ChallengeDrawer/ChallengeDetailsDrawer';
import { DrawerContext } from '../../../contexts';
import { editLiveChatZIndex } from '../../../utils/GeneralUtil';
import { cards } from '../../../constants';
var perksLink = cards.ProXtraPerks.cta.path;
export var DrawerContainer = function () {
    var _a = React.useContext(DrawerContext), drawerOpen = _a.drawerOpen, setDrawerOpen = _a.setDrawerOpen, drawerType = _a.drawerType, setDrawerType = _a.setDrawerType, onDrawerClose = _a.onDrawerClose;
    var drawer;
    useEffect(function () {
        if (drawerType)
            setDrawerType(drawerType);
        editLiveChatZIndex();
    }, [drawerOpen]);
    switch (drawerType) {
        case 'PerksList':
            drawer = React.createElement(PerksListDrawer, null);
            break;
        case 'PerkDetails':
            drawer = React.createElement(PerkDetailsDrawer, null);
            break;
        case 'PerkSelection':
            setDrawerOpen(false);
            window.location.href = perksLink;
            break;
        case 'OffersList':
            drawer = React.createElement(OffersListDrawer, null);
            break;
        case 'OfferDetails':
            drawer = React.createElement(OfferDetailsDrawer, null);
            break;
        case 'ChallengeDetails':
            drawer = React.createElement(ChallengeDetailsDrawer, null);
            break;
        case 'RewardsList':
            drawer = React.createElement(RewardsListDrawer, null);
            break;
        default:
            drawer = React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "DrawerContainerDiv" },
        React.createElement(Drawer, { open: drawerOpen, onClose: onDrawerClose, position: "right", DrawerRootProps: { height: '85%' } }, drawer)));
};
